export enum StatusType {
	INITIAL,
	LOADING,
	SUCCESS,
	FAILED
}

export default StatusType;
